import { render } from "./PlatFormSettingNew.vue?vue&type=template&id=5ae63bd4&scoped=true"
import script from "./PlatFormSettingNew.vue?vue&type=script&lang=js"
export * from "./PlatFormSettingNew.vue?vue&type=script&lang=js"

import "./PlatFormSettingNew.vue?vue&type=style&index=0&id=5ae63bd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae63bd4"]])

export default __exports__